import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetDataSecurityDetectedApplicationsActiveTokensResponse = Record<number, number>;

export const getDataSecurityDetectedApplicationsActiveTokens =
	createGetEndpoint<void, GetDataSecurityDetectedApplicationsActiveTokensResponse>(
		'/api/v3/data-security/applications/active-token-counts'
	);
